/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { VolumeSettings } from '../models/VolumeSettings';

export class RestoreEksNamespaceVolumeInput {
  /**
  * The volume ID to restore
  */
  'providerVolumeId': string;
  /**
  * Optional tags to apply to the output volume
  */
  'tags': { [key: string]: string; };
  /**
  * Optional encryption key ID to use for the output volume
  */
  'volumeEncryptionKeyId'?: string;
  /**
  * Optional encryption key ID to use for the restore process
  */
  'encryptionKeyId'?: string;
  'volumeSettings': VolumeSettings;
  /**
  * Availability zone to restore the volume to.
  */
  'availabilityZone': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "providerVolumeId",
      "baseName": "providerVolumeId",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "volumeEncryptionKeyId",
      "baseName": "volumeEncryptionKeyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "encryptionKeyId",
      "baseName": "encryptionKeyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "volumeSettings",
      "baseName": "volumeSettings",
      "type": "VolumeSettings",
      "format": ""
    },
    {
      "name": "availabilityZone",
      "baseName": "availabilityZone",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreEksNamespaceVolumeInput.attributeTypeMap;
  }

  public constructor() {
  }
}

